import * as Types from '../types/view-elements';

export const createToast = payload => ({
    type    : Types.CREATE_NEW_TOAST,
    payload : payload
});

export const removeToast = payload => ({
    type    : Types.REMOVE_TOAST,
    payload : payload
});

export const createModal = (payload) => ({
    type    : Types.CREATE_NEW_MODAL,
    payload : payload
});

export const removeModal = (payload) => ({
    type    : Types.REMOVE_MODAL,
    payload : payload
});
